<template>
  <div class="main">
    <b-form :class="{'b-layout': true, 'form-geral': true,  'mr-2': true, 'ml-2': true, 'readOnly': readOnly, 'form-geral-read': !readOnly }" @submit.prevent="">
      <div class="varExtrat">
        <div class="mr-2" v-if="!readOnly">
          <p> {{ $t('conf-FCOJ') }} </p>
          <div class="box-edit box-group">
            <span class="mt-2" v-if="!readOnly">
              <b-form-checkbox v-model="disableFCOJ">
                {{ $t('habilitar-fcoj') }}    
              </b-form-checkbox>
            </span>
          </div>
        </div>
        <div class="mr-2" v-if="!disableFCOJ || !readOnly">
          <p> {{ $t('fruta-fcoj') }} </p>
          <div class="box-edit varExtrat" :class="{'marginBot': readOnly}">
            <div class="mr-2 div-top" v-if="!disableFCOJ || !readOnly"> 
              <p> {{ $t('prop-citrus') }} </p>
              <div class="box-edit box-group">
                <div class="box-edit box-conf">
                  <span class="mt-1">
                    <label class="mr-1"> {{ $t('precoce-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp1fcoj" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-1">
                    <label> {{ $t('media-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp2fcoj" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-1">
                    <label> {{ $t('tardia-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp3fcoj" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-2" v-if="!enableDoubledFCOJ">
                    <b-form-checkbox v-model="enableDoubledFCOJ">
                      {{ $t('duplicar-citrus-conf') }}    
                    </b-form-checkbox>
                  </span>

                  <span class="mt-2" v-if="enableDoubledFCOJ">
                    <b-form-checkbox v-model="enableDoubledFCOJ">
                      {{ $t('duplicar-citrus-conf-off') }}
                    </b-form-checkbox>
                  </span>
                </div>

                <div class="box-edit menu-mod">
                  <span class="span-menu">
                    <div>
                      <div v-for="(item, index) in moduleOptionsFCOJ" :key="index">
                        <input :disabled="item.dis" type="checkbox" :id="item.name" @change="changeModuleFCOJ(item)" v-model="item.checked">
                        <label class="ml-1 labelop">{{ item.name }}</label>
                      </div>
                    </div>
                  </span>
                </div>

              </div>
            </div>
            <div class="mr-2">
              <p> {{ $t('qualidade-precoce-citrus') }} </p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp1fcoj" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp1fcoj" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp1fcoj" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp1fcoj" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
    
            <p > {{ $t('qualidade-media-citrus') }} </p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp2fcoj" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp2fcoj" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp2fcoj" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp2fcoj" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
    
            <p>{{ $t('qualidade-tardia-citrus') }}</p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp3fcoj" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp3fcoj" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp3fcoj" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input :disabled="enableDoubledFCOJ" class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp3fcoj" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
            </div>
          </div>
          <p v-if="readOnly && (!disableNFC || !disableRFA)" class="span-oleo-p">{{ $t('p-conf-geral') }}</p>
          <div v-if="readOnly && (!disableNFC || !disableRFA)" class="box-edit span-oleo" :class="{'span-oleo-read-pos': !readOnly}">
            <span class="mt-1" :class="{'read-oleo': readOnly}">
              <label class="mr-1"> {{ $t('oleo-citrus') }} </label>
              <b-input class="input-pentagro input-prop input-oleo" v-model="inputLabel.citrus.chields.oleoFruta" min="0" max="100" step="0.1" type="number"></b-input>
            </span>
          </div>
          <div v-if="!readOnly" class="box-edit mt-2" :class="{'span-oleo-read-pos': !readOnly}">
            <span class="mt-1" :class="{'read-oleo': readOnly}">
              <label class="mr-1"> {{ $t('oleo-citrus') }} </label>
              <b-input class="input-pentagro input-prop input-oleo" v-model="inputLabel.citrus.chields.oleoFruta" min="0" max="100" step="0.1" type="number"></b-input>
            </span>
          </div>
          <p v-if="readOnly && (disableNFC && disableRFA)" class="span-oleo-p mt-3">{{ $t('p-conf-geral') }}</p>
          <div v-if="readOnly && (disableNFC && disableRFA)" class="box-edit mt-1" :class="{'span-oleo-read-pos': !readOnly}">
            <span class="mt-1" :class="{'read-oleo': readOnly}">
              <label class="mr-1"> {{ $t('oleo-citrus') }} </label>
              <b-input class="input-pentagro input-prop input-oleo" v-model="inputLabel.citrus.chields.oleoFruta" min="0" max="100" step="0.1" type="number"></b-input>
            </span>
          </div>
        </div>
      </div>
      <div class="varExtrat">
        <div class="mr-2" v-if="!readOnly">
          <p> {{ $t('conf-NFC') }} </p>
          <div class="box-edit box-group">
            <span class="mt-2" v-if="!readOnly">
              <b-form-checkbox v-model="disableNFC">
                {{ $t('habilitar-nfc') }}    
              </b-form-checkbox>
            </span>
          </div>
        </div>
        <div class="mr-2" v-if="!disableNFC || !readOnly">
          <p> {{ $t('fruta-nfc') }} </p>
          <div class="box-edit varExtrat" :class="{'marginBot': readOnly}">
            <div class="mr-2 div-top"> 
              <p> {{ $t('prop-citrus') }} </p>
              <div class="box-edit box-group">
                <div class="box-edit box-conf">
                  <span class="mt-1">
                    <label class="mr-1"> {{ $t('precoce-citrus') }} </label>
                    <b-input  class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp1nfc" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-1">
                    <label> {{ $t('media-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp2nfc" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-1">
                    <label> {{ $t('tardia-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp3nfc" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-2" v-if="!enableDoubledNFC">
                    <b-form-checkbox v-model="enableDoubledNFC">
                      {{ $t('duplicar-citrus-conf') }}    
                    </b-form-checkbox>
                  </span>
                  <span class="mt-2" v-if="enableDoubledNFC">
                    <b-form-checkbox v-model="enableDoubledNFC">
                      {{ $t('duplicar-citrus-conf-off') }}
                    </b-form-checkbox>
                  </span>
                </div>
                <div class="box-edit menu-mod">
                  <span class="span-menu">
                    <div>
                      <div v-for="(item, index) in moduleOptionsNFC" :key="index">
                        <input :disabled="item.dis" type="checkbox" :id="item.name" @change="changeModuleNFC(item)" v-model="item.checked">
                        <label class="ml-1 labelop">{{ item.name }}</label>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="mr-2">
              <p> {{ $t('qualidade-precoce-citrus') }} </p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp1nfc" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp1nfc" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp1nfc" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp1nfc" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
    
            <p > {{ $t('qualidade-media-citrus') }} </p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp2nfc" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp2nfc" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp2nfc" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp2nfc" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
    
            <p>{{ $t('qualidade-tardia-citrus') }}</p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp3nfc" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp3nfc" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp3nfc" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input :disabled="enableDoubledNFC" class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp3nfc" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
            </div>
          </div>
          <p v-if="readOnly && (disableFCOJ && !disableRFA)" class="span-oleo-p">{{ $t('p-conf-geral') }}</p>
          <div v-if="readOnly && (disableFCOJ && !disableRFA)" class="box-edit span-oleo" :class="{'span-oleo-read-pos': !readOnly}">
            <span class="mt-1" :class="{'read-oleo': readOnly}">
              <label class="mr-1"> {{ $t('oleo-citrus') }} </label>
              <b-input class="input-pentagro input-prop input-oleo" v-model="inputLabel.citrus.chields.oleoFruta" min="0" max="100" step="0.1" type="number"></b-input>
            </span>
          </div>
          
          <p v-if="readOnly && (disableFCOJ && disableRFA)" class="span-oleo-p mt-3">{{ $t('p-conf-geral') }}</p>
          <div v-if="readOnly && (disableFCOJ && disableRFA)" class="box-edit mt-4" :class="{'span-oleo-read-pos': !readOnly}">
            <span class="mt-1" :class="{'read-oleo': readOnly}">
              <label class="mr-1"> {{ $t('oleo-citrus') }} </label>
              <b-input class="input-pentagro input-prop input-oleo" v-model="inputLabel.citrus.chields.oleoFruta" min="0" max="100" step="0.1" type="number"></b-input>
            </span>
          </div>
        </div>
      </div>
      <div class="varExtrat">
        <div class="mr-2" v-if="!readOnly">
          <p> {{ $t('conf-RFA') }} </p>
          <div class="box-edit box-group">
            <span class="mt-2" v-if="!readOnly">
              <b-form-checkbox v-model="disableRFA">
                {{ $t('habilitar-rfa') }}    
              </b-form-checkbox>
            </span>
          </div>
        </div>
        <div v-if="!disableRFA || !readOnly">
          <p> {{ $t('fruta-rfa') }} </p>
          <div class="box-edit varExtrat" :class="{'marginBot': readOnly}">
            <div class="mr-2 div-top"> 
              <p> {{ $t('prop-citrus') }} </p>
              <div class="box-edit box-group">
                <div class="box-edit box-conf">
                  <span class="mt-1">
                    <label class="mr-1"> {{ $t('precoce-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp1rfa" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-1">
                    <label> {{ $t('media-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp2rfa" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-1">
                    <label> {{ $t('tardia-citrus') }} </label>
                    <b-input class="input-pentagro input-prop" v-model="inputLabel.citrus.chields.fmmp3rfa" min="0" max="100" step="0.1" type="number"></b-input>
                  </span>

                  <span class="mt-2" v-if="!enableDoubledRFA">
                    <b-form-checkbox v-model="enableDoubledRFA">
                      {{ $t('duplicar-citrus-conf') }}    
                    </b-form-checkbox>
                  </span>
                  <span class="mt-2" v-if="enableDoubledRFA">
                    <b-form-checkbox v-model="enableDoubledRFA">
                      {{ $t('duplicar-citrus-conf-off') }}
                    </b-form-checkbox>
                  </span>
                </div>
                <div class="box-edit menu-mod">
                  <span class="span-menu">
                    <div>
                      <div v-for="(item, index) in moduleOptionsRFA" :key="index">
                        <input :disabled="item.dis" type="checkbox" :id="item.name" @change="changeModuleRFA(item)" v-model="item.checked">
                        <label class="ml-1 labelop">{{ item.name }}</label>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="mr-2">
              <p> {{ $t('qualidade-precoce-citrus') }} </p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp1rfa" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp1rfa" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp1rfa" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp1rfa" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
    
            <p > {{ $t('qualidade-media-citrus') }} </p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp2rfa" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp2rfa" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp2rfa" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp2rfa" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
    
            <p>{{ $t('qualidade-tardia-citrus') }}</p>
            <div class="box-edit">
              <span>
                <label> {{ $t('brix-1') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.brixmp3rfa" min="0" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('acidez-citrus') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.acidezmp3rfa" min="0" max="100" step="0.1" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('tamanho-citrus') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.tamanhomp3rfa" min="0" max="100" step="0.01" type="number"></b-input>
              </span>
    
              <span>
                <label> {{ $t('frutas-caixa-citrus') }} </label>
                <b-input :disabled="enableDoubledRFA" class="input-pentagro" v-model="inputLabel.citrus.chields.sucocxmp3rfa" min="0" max="100" step="0.5" type="number"></b-input>
              </span>
            </div>
            </div>
          </div>
          <p v-if="readOnly && (disableFCOJ && disableNFC)" class="span-oleo-p mt-3">{{ $t('p-conf-geral') }}</p>
          <div v-if="readOnly && (disableFCOJ && disableNFC)" class="box-edit mt-4" :class="{'span-oleo-read-pos': !readOnly}">
            <span class="mt-1" :class="{'read-oleo': readOnly}">
              <label class="mr-1"> {{ $t('oleo-citrus') }} </label>
              <b-input class="input-pentagro input-prop input-oleo" v-model="inputLabel.citrus.chields.oleoFruta" min="0" max="100" step="0.1" type="number"></b-input>
            </span>
          </div>
          
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import { urlMainAPI, defaultSuccess } from "@/global";
import { SingletonEnginnering } from "../_service/singletonEngineering"
import { NumberFormat ,ParseToNumber } from "../../utils/tools"
import { WaitMixin } from "../../../mixins/waitMixin"

  export default {
    props: {
      node: {
        type: Object,
        default: null
      },
      importONLS: {
        type: Number
      },
      readOnly:{
      type: Boolean,
      default: false,
    }
    },

    mixins: [ WaitMixin ],

    data() {
      return {
        unitId: parseInt(this.$store.state.user.UnitId),
        firstLoad: true,
        showStraw: this.node.showStraw,
        enableDoubledFCOJ: this.node.enableDoubledFCOJ,
        enableDoubledNFC: this.node.enableDoubledNFC,
        enableDoubledRFA: this.node.enableDoubledRFA,
        disableFCOJ: this.node.disableFCOJ,
        disableNFC: this.node.disableNFC,
        disableRFA: this.node.disableRFA,
        modulesToShow: "",
        linesFCOJ: [],
        linesNFC: [],
        linesRFA: [],
        moduleSeletion: "",
        moduleOptionsFCOJ: [],
        moduleOptionsNFC: [],
        moduleOptionsRFA: [],
        fruitOp: ["FCOJ", "NFC", "RFA"],
        propPrecoce: '',
        propMedia: '',
        propTardia: '',
        straw: {},
        operationsCitrus: SingletonEnginnering.operations.filter(cr => String(cr).match(/\bEX+/g)),
        currents: SingletonEnginnering.currents,
        inputLabel: {
          citrus: { 
            caption: 'Qualidade do Citrus',
            attrs: [],
            current: '',
            currentStraw: '',
            chields: {
              fmmp1fcoj: 0,
              fmmp2fcoj: 0,
              fmmp3fcoj: 0,
              brixmp1fcoj: 0,
              brixmp2fcoj: 0,
              brixmp3fcoj: 0,
              acidezmp1fcoj: 0,
              acidezmp2fcoj: 0,
              acidezmp3fcoj: 0,
              tamanhomp1fcoj: 0,
              tamanhomp2fcoj: 0,
              tamanhomp3fcoj: 0,
              sucocxmp1fcoj: 0,
              sucocxmp2fcoj: 0,
              sucocxmp3fcoj: 0,

              fmmp1nfc: 0,
              fmmp2nfc: 0,
              fmmp3nfc: 0,
              brixmp1nfc: 0,
              brixmp2nfc: 0,
              brixmp3nfc: 0,
              acidezmp1nfc: 0,
              acidezmp2nfc: 0,
              acidezmp3nfc: 0,
              tamanhomp1nfc: 0,
              tamanhomp2nfc: 0,
              tamanhomp3nfc: 0,
              sucocxmp1nfc: 0,
              sucocxmp2nfc: 0,
              sucocxmp3nfc: 0,

              fmmp1rfa: 0,
              fmmp2rfa: 0,
              fmmp3rfa: 0,
              brixmp1rfa: 0,
              brixmp2rfa: 0,
              brixmp3rfa: 0,
              acidezmp1rfa: 0,
              acidezmp2rfa: 0,
              acidezmp3rfa: 0,
              tamanhomp1rfa: 0,
              tamanhomp2rfa: 0,
              tamanhomp3rfa: 0,
              sucocxmp1rfa: 0,
              sucocxmp2rfa: 0,
              sucocxmp3rfa: 0,

              oleoFruta: 0,
            }
          }
        }
      }
    },

    watch:{
      "inputLabel.citrus.chields.fmmp1fcoj"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp1fcoj = value;

        let fm1 = value
        let fm2 = parseFloat(this.inputLabel.citrus.chields.fmmp2fcoj)
        let fm3 = parseFloat(this.inputLabel.citrus.chields.fmmp3fcoj)

        var shouldError = false

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true;

          let valueTo100 = (100 - (fm2 + fm3)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp1fcoj = valueTo100;
          }, 100);
        }

        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp2fcoj"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp2fcoj = value;
        
        let fm1 = parseFloat(this.inputLabel.citrus.chields.fmmp1fcoj)
        let fm2 = value
        let fm3 = parseFloat(this.inputLabel.citrus.chields.fmmp3fcoj)

        var shouldError = false;

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true;

          let valueTo100 = (100 - (fm1 + fm3)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp2fcoj = valueTo100;
          }, 100);
        }

        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp3fcoj"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp3fcoj = value;

        let fm1 = parseFloat(this.inputLabel.citrus.chields.fmmp1fcoj)
        let fm2 = parseFloat(this.inputLabel.citrus.chields.fmmp2fcoj)
        let fm3 = value

        var shouldError = false;

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true;

          let valueTo100 = (100 - (fm1 + fm2)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp3fcoj = valueTo100;
          }, 100);
        }

        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp1nfc"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp1nfc = value;

        let fm1 = value
        let fm2 = parseFloat(this.inputLabel.citrus.chields.fmmp2nfc)
        let fm3 = parseFloat(this.inputLabel.citrus.chields.fmmp3nfc)

        var shouldError = false;

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true;

          let valueTo100 = (100 - (fm2 + fm3)).toString();
          
          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp1nfc = valueTo100;
          }, 100);
        }

        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp2nfc"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp2nfc = value;
        
        let fm1 = parseFloat(this.inputLabel.citrus.chields.fmmp1nfc)
        let fm2 = value
        let fm3 = parseFloat(this.inputLabel.citrus.chields.fmmp3nfc)

        var shouldError = false

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true;

          let valueTo100 = (100 - (fm1 + fm3)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp2nfc = valueTo100;
          }, 100);
        }

        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp3nfc"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp3nfc = value

        let fm1 = parseFloat(this.inputLabel.citrus.chields.fmmp1nfc)
        let fm2 = parseFloat(this.inputLabel.citrus.chields.fmmp2nfc)
        let fm3 = value

        var shouldError = false

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true

          let valueTo100 = (100 - (fm1 + fm2)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp3nfc = valueTo100;
          }, 100);
        } 

        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp1rfa"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp1rfa = value;

        let fm1 = value
        let fm2 = parseFloat(this.inputLabel.citrus.chields.fmmp2rfa)
        let fm3 = parseFloat(this.inputLabel.citrus.chields.fmmp3rfa)

        var shouldError = false

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true;

          let valueTo100 = (100 - (fm2 + fm3)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp1rfa = valueTo100;
          }, 100);
        }

        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp2rfa"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp2rfa = value;
        
        let fm1 = parseFloat(this.inputLabel.citrus.chields.fmmp1rfa)
        let fm2 = value
        let fm3 = parseFloat(this.inputLabel.citrus.chields.fmmp3rfa)

        var shouldError = false

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true

          let valueTo100 = (100 - (fm1 + fm3)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp2rfa = valueTo100;
          }, 100);
        }

        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          } 
        }, 100);

        this.updateNode();
      },

      "inputLabel.citrus.chields.fmmp3rfa"(value) 
      {
        if(value == '') return;
        value = parseFloat(value);
        value = value > 100 ? 100 : value;
        value = value < 0 ? 0 : value;

        this.inputLabel.citrus.chields.fmmp3rfa = value;

        let fm1 = parseFloat(this.inputLabel.citrus.chields.fmmp1rfa)
        let fm2 = parseFloat(this.inputLabel.citrus.chields.fmmp2rfa)
        let fm3 = value

        var shouldError = false 

        if ((fm1 + fm2 + fm3) > 100 && value != 0) 
        {
          shouldError = true;

          let valueTo100 = (100 - (fm1 + fm2)).toString();

          setTimeout(() => {
            this.inputLabel.citrus.chields.fmmp3rfa = valueTo100;
          }, 100);
        }

        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "fm_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa);
                }
                if(a.key == "fm_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa);
                }
                if(a.key == "fm_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa);
                }
              })
            } 
          }
        });

        setTimeout(() => {
          if (shouldError) 
          {
            defaultSuccess(this.$t('erro-total-citrus-fm'))
          }
        }, 500);

        this.updateNode();
      },

      enableDoubledFCOJ(value) {
        if (value) 
        {
          this.inputLabel.citrus.chields.brixmp2fcoj = this.inputLabel.citrus.chields.brixmp1fcoj; 
          this.inputLabel.citrus.chields.brixmp3fcoj = this.inputLabel.citrus.chields.brixmp1fcoj; 

          this.inputLabel.citrus.chields.acidezmp2fcoj = this.inputLabel.citrus.chields.acidezmp1fcoj; 
          this.inputLabel.citrus.chields.acidezmp3fcoj = this.inputLabel.citrus.chields.acidezmp1fcoj; 

          this.inputLabel.citrus.chields.tamanhomp2fcoj = this.inputLabel.citrus.chields.tamanhomp1fcoj; 
          this.inputLabel.citrus.chields.tamanhomp3fcoj = this.inputLabel.citrus.chields.tamanhomp1fcoj; 

          this.inputLabel.citrus.chields.sucocxmp2fcoj = this.inputLabel.citrus.chields.sucocxmp1fcoj; 
          this.inputLabel.citrus.chields.sucocxmp3fcoj = this.inputLabel.citrus.chields.sucocxmp1fcoj; 
        }
        this.updateNode();
      },

      enableDoubledNFC(value) {
        if (value) 
        {
          this.inputLabel.citrus.chields.brixmp2nfc = this.inputLabel.citrus.chields.brixmp1nfc; 
          this.inputLabel.citrus.chields.brixmp3nfc = this.inputLabel.citrus.chields.brixmp1nfc; 

          this.inputLabel.citrus.chields.acidezmp2nfc = this.inputLabel.citrus.chields.acidezmp1nfc; 
          this.inputLabel.citrus.chields.acidezmp3nfc = this.inputLabel.citrus.chields.acidezmp1nfc; 

          this.inputLabel.citrus.chields.tamanhomp2nfc = this.inputLabel.citrus.chields.tamanhomp1nfc; 
          this.inputLabel.citrus.chields.tamanhomp3nfc = this.inputLabel.citrus.chields.tamanhomp1nfc; 

          this.inputLabel.citrus.chields.sucocxmp2nfc = this.inputLabel.citrus.chields.sucocxmp1nfc; 
          this.inputLabel.citrus.chields.sucocxmp3nfc = this.inputLabel.citrus.chields.sucocxmp1nfc; 
        }
        this.updateNode();
      },

      enableDoubledRFA(value) {
        if (value) 
        {
          this.inputLabel.citrus.chields.brixmp2rfa = this.inputLabel.citrus.chields.brixmp1rfa; 
          this.inputLabel.citrus.chields.brixmp3rfa = this.inputLabel.citrus.chields.brixmp1rfa; 

          this.inputLabel.citrus.chields.acidezmp2rfa = this.inputLabel.citrus.chields.acidezmp1rfa; 
          this.inputLabel.citrus.chields.acidezmp3rfa = this.inputLabel.citrus.chields.acidezmp1rfa; 

          this.inputLabel.citrus.chields.tamanhomp2rfa = this.inputLabel.citrus.chields.tamanhomp1rfa; 
          this.inputLabel.citrus.chields.tamanhomp3rfa = this.inputLabel.citrus.chields.tamanhomp1rfa; 

          this.inputLabel.citrus.chields.sucocxmp2rfa = this.inputLabel.citrus.chields.sucocxmp1rfa; 
          this.inputLabel.citrus.chields.sucocxmp3rfa = this.inputLabel.citrus.chields.sucocxmp1rfa; 
        }
        this.updateNode();
      },

      disableFCOJ() {
        this.updateNode();
      },

      disableNFC() {
        this.updateNode();
      },

      disableRFA() {
        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp1fcoj"(value){
        if(this.firstLoad) return;

        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index == "Custom|EX_103" || a.index == "Custom|EX_103")) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledFCOJ && (a.index == "Custom|EX_103" || a.index == "Custom|EX_104")) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp2fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2fcoj = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp3fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp1nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp2nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2nfc = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp3nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp1rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "brix_mp2" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
                if(a.key == "brix_mp3" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp2rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp2rfa = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.brixmp3rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "brix_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.brixmp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp1fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp2fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2fcoj = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp3fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp1nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp2nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2nfc = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp3nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp1rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "acidez_mp2" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
                if(a.key == "acidez_mp3" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp2rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp2rfa = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.acidezmp3rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "acidez_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.acidezmp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp1fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp2fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp3fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp1nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp2nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2nfc = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp3nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp1rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "frutas_por_cx_mp2" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
                if(a.key == "frutas_por_cx_mp3" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp2rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp2rfa = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.tamanhomp3rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "frutas_por_cx_mp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.tamanhomp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp1fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledFCOJ && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledFCOJ && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledFCOJ && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledFCOJ && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledFCOJ && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledFCOJ && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp2fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp3fcoj"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsFCOJ.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp1nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledNFC && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledNFC && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledNFC && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledNFC && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledNFC && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp2nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2nfc = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp3nfc"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsNFC.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3nfc = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp1rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledRFA && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledRFA && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledRFA && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledRFA && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp1" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value);
                }
                if(a.key == "porcsucomp2" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
                if(a.key == "porcsucomp3" && this.enableDoubledRFA && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp2rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp2" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp2rfa = value; 
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.sucocxmp3rfa"(value){
        if(this.firstLoad) return;
        
        this.moduleOptionsRFA.forEach(e => {
          if (e.checked) 
          {
            if(e.name == "Módulo 1") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_101") || a.index.includes("EX_102"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 2") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_103") || a.index.includes("EX_104"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 3") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_105") || a.index.includes("EX_106"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 4") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_107") || a.index.includes("EX_108"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
            if(e.name == "Módulo 5") 
            {
              this.inputLabel.citrus.attrs.forEach(a => {
                if(a.key == "porcsucomp3" && (a.index.includes("EX_109") || a.index.includes("EX_110"))) 
                {
                  a.value = NumberFormat(value)
                  this.inputLabel.citrus.chields.sucocxmp3rfa = value;
                }
              })
            } 
          }
        });

        this.updateNode();
      },

      "inputLabel.citrus.chields.oleoFruta"(value){
        if(this.firstLoad) return;
        
        this.inputLabel.citrus.attrs.forEach(a => {
          if(a.key == "oleo_disp_mp1" || a.key == "oleo_disp_mp2" || a.key == "oleo_disp_mp3") 
          {
            a.value = NumberFormat(value)
            this.inputLabel.citrus.chields.oleoFruta = value;
          }
        })

        this.updateNode();
      },

      importONLS(){
        this.waitOn()

        let listTags = 
        [  
          'input_online_BrixCitrusFCOJ',
          'input_online_AcidezCitrusFCOJ',
          'input_online_FrutasCxCitrusFCOJ',
          'input_online_SucoCxCitrusFCOJ',

          'input_online_BrixCitrusNFC',
          'input_online_AcidezCitrusNFC',
          'input_online_FrutasCxCitrusNFC',
          'input_online_SucoCxCitrusNFC',

          'input_online_BrixCitrusRFA',
          'input_online_AcidezCitrusRFA',
          'input_online_FrutasCxCitrusRFA',
          'input_online_SucoCxCitrusRFA',

          'input_online_fmCitrusFCOJ',
          'input_online_fmCitrusNFC',
          'input_online_fmCitrusRFA',
        ]

        listTags.forEach(li => 
        {
          listTags.push(li + '_PC'); 
          listTags.push(li + '_MD'); 
          listTags.push(li + '_TD'); 
        });

        defaultSuccess(this.$t('importando-dados-do-processo'))
        
        console.log('Importar dados do citrus com as tags :>> ', listTags);
        
        axios.post(`${urlMainAPI}/getcitrusquality`, listTags).then(resp => {
          if(resp.status == 200)
            defaultSuccess(this.$t('dados-importados-com-sucesso'))
            let result = resp.data
            
            for (const prop in result) 
            {
              result[prop] = parseFloat(result[prop]).toFixed(2);
            }

            this.inputLabel.citrus.chields.fmmp1fcoj = parseFloat(result[listTags[51]])
            this.inputLabel.citrus.chields.fmmp2fcoj = parseFloat(result[listTags[52]])
            this.inputLabel.citrus.chields.fmmp3fcoj = parseFloat(result[listTags[53]])

            this.inputLabel.citrus.chields.fmmp1nfc = parseFloat(result[listTags[54]])
            this.inputLabel.citrus.chields.fmmp2nfc = parseFloat(result[listTags[55]])
            this.inputLabel.citrus.chields.fmmp3nfc = parseFloat(result[listTags[56]])

            this.inputLabel.citrus.chields.fmmp1rfa = parseFloat(result[listTags[57]])
            this.inputLabel.citrus.chields.fmmp2rfa = parseFloat(result[listTags[58]])
            this.inputLabel.citrus.chields.fmmp3rfa = parseFloat(result[listTags[59]])
            
            if(result[listTags[0]] == undefined) 
            {
              this.inputLabel.citrus.chields.brixmp1fcoj = parseFloat(result[listTags[15]])
              this.inputLabel.citrus.chields.brixmp2fcoj = parseFloat(result[listTags[16]])
              this.inputLabel.citrus.chields.brixmp3fcoj = parseFloat(result[listTags[17]])
  
              this.inputLabel.citrus.chields.acidezmp1fcoj = parseFloat(result[listTags[18]])
              this.inputLabel.citrus.chields.acidezmp2fcoj = parseFloat(result[listTags[19]])
              this.inputLabel.citrus.chields.acidezmp3fcoj = parseFloat(result[listTags[20]])
  
              this.inputLabel.citrus.chields.tamanhomp1fcoj = parseFloat(result[listTags[21]])
              this.inputLabel.citrus.chields.tamanhomp2fcoj = parseFloat(result[listTags[22]])
              this.inputLabel.citrus.chields.tamanhomp3fcoj = parseFloat(result[listTags[23]])
  
              this.inputLabel.citrus.chields.sucocxmp1fcoj = parseFloat(result[listTags[24]])
              this.inputLabel.citrus.chields.sucocxmp2fcoj = parseFloat(result[listTags[25]])
              this.inputLabel.citrus.chields.sucocxmp3fcoj = parseFloat(result[listTags[26]])
            } else 
            {
              this.inputLabel.citrus.chields.brixmp1fcoj = parseFloat(result[listTags[0]])
              this.inputLabel.citrus.chields.brixmp2fcoj = parseFloat(result[listTags[0]])
              this.inputLabel.citrus.chields.brixmp3fcoj = parseFloat(result[listTags[0]])
  
              this.inputLabel.citrus.chields.acidezmp1fcoj = parseFloat(result[listTags[1]])
              this.inputLabel.citrus.chields.acidezmp2fcoj = parseFloat(result[listTags[1]])
              this.inputLabel.citrus.chields.acidezmp3fcoj = parseFloat(result[listTags[1]])
  
              this.inputLabel.citrus.chields.tamanhomp1fcoj = parseFloat(result[listTags[2]])
              this.inputLabel.citrus.chields.tamanhomp2fcoj = parseFloat(result[listTags[2]])
              this.inputLabel.citrus.chields.tamanhomp3fcoj = parseFloat(result[listTags[2]])
  
              this.inputLabel.citrus.chields.sucocxmp1fcoj = parseFloat(result[listTags[3]])
              this.inputLabel.citrus.chields.sucocxmp2fcoj = parseFloat(result[listTags[3]])
              this.inputLabel.citrus.chields.sucocxmp3fcoj = parseFloat(result[listTags[3]])
            }
            if(result[listTags[4]] == undefined) 
            {
              this.inputLabel.citrus.chields.brixmp1nfc = parseFloat(result[listTags[27]])
              this.inputLabel.citrus.chields.brixmp2nfc = parseFloat(result[listTags[28]])
              this.inputLabel.citrus.chields.brixmp3nfc = parseFloat(result[listTags[29]])
  
              this.inputLabel.citrus.chields.acidezmp1nfc = parseFloat(result[listTags[30]])
              this.inputLabel.citrus.chields.acidezmp2nfc = parseFloat(result[listTags[31]])
              this.inputLabel.citrus.chields.acidezmp3nfc = parseFloat(result[listTags[32]])
  
              this.inputLabel.citrus.chields.tamanhomp1nfc = parseFloat(result[listTags[33]])
              this.inputLabel.citrus.chields.tamanhomp2nfc = parseFloat(result[listTags[34]])
              this.inputLabel.citrus.chields.tamanhomp3nfc = parseFloat(result[listTags[35]])
  
              this.inputLabel.citrus.chields.sucocxmp1nfc = parseFloat(result[listTags[36]])
              this.inputLabel.citrus.chields.sucocxmp2nfc = parseFloat(result[listTags[37]])
              this.inputLabel.citrus.chields.sucocxmp3nfc = parseFloat(result[listTags[38]])
            } else 
            {
              this.inputLabel.citrus.chields.brixmp1nfc = parseFloat(result[listTags[4]])
              this.inputLabel.citrus.chields.brixmp2nfc = parseFloat(result[listTags[4]])
              this.inputLabel.citrus.chields.brixmp3nfc = parseFloat(result[listTags[4]])
  
              this.inputLabel.citrus.chields.acidezmp1nfc = parseFloat(result[listTags[5]])
              this.inputLabel.citrus.chields.acidezmp2nfc = parseFloat(result[listTags[5]])
              this.inputLabel.citrus.chields.acidezmp3nfc = parseFloat(result[listTags[5]])
  
              this.inputLabel.citrus.chields.tamanhomp1nfc = parseFloat(result[listTags[6]])
              this.inputLabel.citrus.chields.tamanhomp2nfc = parseFloat(result[listTags[6]])
              this.inputLabel.citrus.chields.tamanhomp3nfc = parseFloat(result[listTags[6]])
  
              this.inputLabel.citrus.chields.sucocxmp1nfc = parseFloat(result[listTags[7]])
              this.inputLabel.citrus.chields.sucocxmp2nfc = parseFloat(result[listTags[7]])
              this.inputLabel.citrus.chields.sucocxmp3nfc = parseFloat(result[listTags[7]])
            }
            if(result[listTags[8]] == undefined) 
            {
              this.inputLabel.citrus.chields.brixmp1rfa = parseFloat(result[listTags[39]])
              this.inputLabel.citrus.chields.brixmp2rfa = parseFloat(result[listTags[40]])
              this.inputLabel.citrus.chields.brixmp3rfa = parseFloat(result[listTags[41]])
  
              this.inputLabel.citrus.chields.acidezmp1rfa = parseFloat(result[listTags[42]])
              this.inputLabel.citrus.chields.acidezmp2rfa = parseFloat(result[listTags[43]])
              this.inputLabel.citrus.chields.acidezmp3rfa = parseFloat(result[listTags[44]])
  
              this.inputLabel.citrus.chields.tamanhomp1rfa = parseFloat(result[listTags[45]])
              this.inputLabel.citrus.chields.tamanhomp2rfa = parseFloat(result[listTags[46]])
              this.inputLabel.citrus.chields.tamanhomp3rfa = parseFloat(result[listTags[47]])
  
              this.inputLabel.citrus.chields.sucocxmp1rfa = parseFloat(result[listTags[48]])
              this.inputLabel.citrus.chields.sucocxmp2rfa = parseFloat(result[listTags[49]])
              this.inputLabel.citrus.chields.sucocxmp3rfa = parseFloat(result[listTags[50]])
            } else 
            {
              this.inputLabel.citrus.chields.brixmp1rfa = parseFloat(result[listTags[8]])
              this.inputLabel.citrus.chields.brixmp2rfa = parseFloat(result[listTags[8]])
              this.inputLabel.citrus.chields.brixmp3rfa = parseFloat(result[listTags[8]])
  
              this.inputLabel.citrus.chields.acidezmp1rfa = parseFloat(result[listTags[9]])
              this.inputLabel.citrus.chields.acidezmp2rfa = parseFloat(result[listTags[9]])
              this.inputLabel.citrus.chields.acidezmp3rfa = parseFloat(result[listTags[9]])
  
              this.inputLabel.citrus.chields.tamanhomp1rfa = parseFloat(result[listTags[10]])
              this.inputLabel.citrus.chields.tamanhomp2rfa = parseFloat(result[listTags[10]])
              this.inputLabel.citrus.chields.tamanhomp3rfa = parseFloat(result[listTags[10]])
  
              this.inputLabel.citrus.chields.sucocxmp1rfa = parseFloat(result[listTags[11]])
              this.inputLabel.citrus.chields.sucocxmp2rfa = parseFloat(result[listTags[11]])
              this.inputLabel.citrus.chields.sucocxmp3rfa = parseFloat(result[listTags[11]])
            }
             
            this.waitOff()
        }).catch(err => {console.log(err);  this.waitOff()})
      },
    },
      
    methods: {
      loadNode(){
        this.firstLoad = true;

        let attrs = new Array();
        this.inputLabel.citrus.attrs = [];

        this.disableFCOJ = this.node.disableFCOJ;
        this.disableRFA = this.node.disableRFA;
        this.disableNFC = this.node.disableNFC;
        
        this.propPrecoce = this.node.propPrecoce;
        this.propMedia = this.node.propMedia;
        this.propTardia = this.node.propTardia;

        this.linesFCOJ = this.node.linesFCOJ;
        this.linesNFC = this.node.linesNFC;
        this.linesRFA = this.node.linesRFA;
        
        this.moduleOptionsFCOJ = this.node.moduleOptionsFCOJ;
        this.moduleOptionsNFC = this.node.moduleOptionsNFC;
        this.moduleOptionsRFA = this.node.moduleOptionsRFA;
        
        this.node.data.forEach((a) => 
          {
            if (a.index.includes("EX_101")) 
            {
              if(a.key == "oleo_disp_mp1") 
              {
                this.inputLabel.citrus.chields.oleoFruta = ParseToNumber(a.value)
              }
            }
          })

        //População dos arrays de modulos de todas as frutas
        this.moduleOptionsFCOJ = [];
        this.moduleOptionsNFC = [];
        this.moduleOptionsRFA = [];

        setTimeout(() => {}, 1000);

        let countop = this.operationsCitrus.length;
        let oddCount = (countop%2) == 0 ? false : true;
        let qtdMod = 0;
        
        if(!oddCount) 
        {
          qtdMod = countop / 2 
        } else {
          qtdMod = (countop - 1) / 2
        }
        
        let nameMod = "Módulo"
        for(let i = 0; i < qtdMod; i++) 
        {
          this.moduleOptionsFCOJ.push({ name: nameMod + " " + (i + 1).toString(), checked: false, dis: false})
          this.moduleOptionsNFC.push({ name: nameMod + " " + (i + 1).toString(), checked: false, dis: false})
          this.moduleOptionsRFA.push({ name: nameMod + " " + (i + 1).toString(), checked: false, dis: false})
        }
        
        if (oddCount) 
        {
          this.moduleOptionsFCOJ.push({ name: nameMod + " " + (qtdMod + 1).toString(), checked: false, dis: false})
          this.moduleOptionsNFC.push({ name: nameMod + " " + (qtdMod + 1).toString(), checked: false, dis: false})
          this.moduleOptionsRFA.push({ name: nameMod + " " + (qtdMod + 1).toString(), checked: false, dis: false})
        }

        var pair101Off = true;
        var pair103Off = true;
        var pair105Off = true;
        var pair107Off = true;
        var pair109Off = true;

        this.operationsCitrus.forEach(line => {
          let propOp = SingletonEnginnering.getOperationsProperties(line);

          propOp.forEach(propOfLine2 => 
          {
            if(this.operationsCitrus.includes("Custom|EX_102")) 
            {
              if (propOfLine2.key == "status" && ParseToNumber(propOfLine2.value) != 0 && propOfLine2.index.includes("EX_102")) pair101Off = false
            }

            if(this.operationsCitrus.includes("Custom|EX_104")) 
            {
              if (propOfLine2.key == "status" && ParseToNumber(propOfLine2.value) != 0 && propOfLine2.index.includes("EX_104")) pair103Off = false
            }

            if(this.operationsCitrus.includes("Custom|EX_106")) 
            {
              if (propOfLine2.key == "status" && ParseToNumber(propOfLine2.value) != 0 && propOfLine2.index.includes("EX_106")) pair105Off = false
            }

            if(this.operationsCitrus.includes("Custom|EX_108")) 
            {
              if (propOfLine2.key == "status" && ParseToNumber(propOfLine2.value) != 0 && propOfLine2.index.includes("EX_108")) pair107Off = false
            }

            if(this.operationsCitrus.includes("Custom|EX_110")) 
            {
              if (propOfLine2.key == "status" && ParseToNumber(propOfLine2.value) != 0 && propOfLine2.index.includes("EX_110")) pair109Off = false
            }
          });
        });

        this.operationsCitrus.forEach(line => {
          let propOp = SingletonEnginnering.getOperationsProperties(line);

          propOp.forEach(propOfLine => 
          {
              if (propOfLine.key == "tipo_produto" && propOfLine.index.includes("EX_101")) 
              {
                if (ParseToNumber(propOfLine.value) == 1) 
                {
                  this.moduleOptionsNFC[0].checked = true;
                  
                  this.moduleOptionsFCOJ[0].checked = false;
                  this.moduleOptionsFCOJ[0].dis = true;
                  this.moduleOptionsRFA[0].checked = false;
                  this.moduleOptionsRFA[0].dis = true;

                  this.changeModuleNFC(this.moduleOptionsNFC[0])
                }
                if (ParseToNumber(propOfLine.value) == 2) 
                {
                  this.moduleOptionsFCOJ[0].checked = true;
  
                  this.moduleOptionsNFC[0].checked = false;
                  this.moduleOptionsNFC[0].dis = true;
                  this.moduleOptionsRFA[0].checked = false;
                  this.moduleOptionsRFA[0].dis = true;

                  this.changeModuleFCOJ(this.moduleOptionsFCOJ[0])
                }
                if (ParseToNumber(propOfLine.value) == 3) 
                {
                  this.moduleOptionsRFA[0].checked = true;
                  
                  this.moduleOptionsFCOJ[0].checked = false;
                  this.moduleOptionsFCOJ[0].dis = true;
                  this.moduleOptionsNFC[0].checked = false;
                  this.moduleOptionsNFC[0].dis = true;

                  this.changeModuleRFA(this.moduleOptionsRFA[0])
                }
              }
  
              if (propOfLine.key == "tipo_produto" && propOfLine.index.includes("EX_103")) 
              {
                if (ParseToNumber(propOfLine.value) == 1) 
                {
                  this.moduleOptionsNFC[1].checked = true;
                  
                  this.moduleOptionsFCOJ[1].checked = false;
                  this.moduleOptionsFCOJ[1].dis = true;
                  this.moduleOptionsRFA[1].checked = false;
                  this.moduleOptionsRFA[1].dis = true;

                  this.changeModuleNFC(this.moduleOptionsNFC[1])
                }
                if (ParseToNumber(propOfLine.value) == 2) 
                {
                  this.moduleOptionsFCOJ[1].checked = true;
  
                  this.moduleOptionsNFC[1].checked = false;
                  this.moduleOptionsNFC[1].dis = true;
                  this.moduleOptionsRFA[1].checked = false;
                  this.moduleOptionsRFA[1].dis = true;

                  this.changeModuleFCOJ(this.moduleOptionsFCOJ[1])
                }
                if (ParseToNumber(propOfLine.value) == 3) 
                {
                  this.moduleOptionsRFA[1].checked = true;
  
                  this.moduleOptionsFCOJ[1].checked = false;
                  this.moduleOptionsFCOJ[1].dis = true;
                  this.moduleOptionsNFC[1].checked = false;
                  this.moduleOptionsNFC[1].dis = true;

                  this.changeModuleRFA(this.moduleOptionsRFA[1])
                }
              }
  
              if (propOfLine.key == "tipo_produto" && propOfLine.index.includes("EX_105")) 
              {
                if (ParseToNumber(propOfLine.value) == 1) 
                {
                  this.moduleOptionsNFC[2].checked = true;
                  
                  this.moduleOptionsFCOJ[2].checked = false;
                  this.moduleOptionsFCOJ[2].dis = true;
                  this.moduleOptionsRFA[2].checked = false;
                  this.moduleOptionsRFA[2].dis = true;

                  this.changeModuleNFC(this.moduleOptionsNFC[2])
                }
                if (ParseToNumber(propOfLine.value) == 2) 
                {
                  this.moduleOptionsFCOJ[2].checked = true;
                  
                  this.moduleOptionsNFC[2].checked = false;
                  this.moduleOptionsNFC[2].dis = true;
                  this.moduleOptionsRFA[2].checked = false;
                  this.moduleOptionsRFA[2].dis = true;

                  this.changeModuleFCOJ(this.moduleOptionsFCOJ[2])
                }
                if (ParseToNumber(propOfLine.value) == 3) 
                {
                  this.moduleOptionsRFA[2].checked = true;
                  
                  this.moduleOptionsFCOJ[2].checked = false;
                  this.moduleOptionsFCOJ[2].dis = true;
                  this.moduleOptionsNFC[2].checked = false;
                  this.moduleOptionsNFC[2].dis = true;

                  this.changeModuleRFA(this.moduleOptionsRFA[2])
                }
              }
              
              if (propOfLine.key == "tipo_produto" && propOfLine.index.includes("EX_107")) 
              {
                if (ParseToNumber(propOfLine.value) == 1) 
                {
                  this.moduleOptionsNFC[3].checked = true;
  
                  this.moduleOptionsFCOJ[3].checked = false;
                  this.moduleOptionsFCOJ[3].dis = true;
                  this.moduleOptionsRFA[3].checked = false;
                  this.moduleOptionsRFA[3].dis = true;

                  this.changeModuleNFC(this.moduleOptionsNFC[3])
                }
                if (ParseToNumber(propOfLine.value) == 2) 
                {
                  this.moduleOptionsFCOJ[3].checked = true;
  
                  this.moduleOptionsNFC[3].checked = false;
                  this.moduleOptionsNFC[3].dis = true;
                  this.moduleOptionsRFA[3].checked = false;
                  this.moduleOptionsRFA[3].dis = true;

                  this.changeModuleFCOJ(this.moduleOptionsFCOJ[3])
                }
                if (ParseToNumber(propOfLine.value) == 3) 
                {
                  this.moduleOptionsRFA[3].checked = true;
  
                  this.moduleOptionsFCOJ[3].checked = false;
                  this.moduleOptionsFCOJ[3].dis = true;
                  this.moduleOptionsNFC[3].checked = false;
                  this.moduleOptionsNFC[3].dis = true;

                  this.changeModuleRFA(this.moduleOptionsRFA[3])
                }
              }
              
              if (propOfLine.key == "tipo_produto" && propOfLine.index.includes("EX_109")) 
              {
                if (ParseToNumber(propOfLine.value) == 1) 
                {
                  this.moduleOptionsNFC[4].checked = true;
                  
                  this.moduleOptionsFCOJ[4].checked = false;
                  this.moduleOptionsFCOJ[4].dis = true;
                  this.moduleOptionsRFA[4].checked = false;
                  this.moduleOptionsRFA[4].dis = true;

                  this.changeModuleNFC(this.moduleOptionsNFC[4])
                }
                if (ParseToNumber(propOfLine.value) == 2) 
                {
                  this.moduleOptionsFCOJ[4].checked = true;
  
                  this.moduleOptionsNFC[4].checked = false;
                  this.moduleOptionsNFC[4].dis = true;
                  this.moduleOptionsRFA[4].checked = false;
                  this.moduleOptionsRFA[4].dis = true;

                  this.changeModuleFCOJ(this.moduleOptionsFCOJ[4])
                }
                if (ParseToNumber(propOfLine.value) == 3) 
                {
                  this.moduleOptionsRFA[4].checked = true;
                  
                  this.moduleOptionsFCOJ[4].checked = false;
                  this.moduleOptionsFCOJ[4].dis = true;
                  this.moduleOptionsNFC[4].checked = false;
                  this.moduleOptionsNFC[4].dis = true;

                  this.changeModuleRFA(this.moduleOptionsRFA[4])
                }
              }

              if (propOfLine.key == "status" && ParseToNumber(propOfLine.value) == 0 && propOfLine.index.includes("EX_101")) 
              {
                if(pair101Off) 
                {
                  let option = this.moduleOptionsNFC[0].checked == true ? 1 : this.moduleOptionsFCOJ[0].checked == true ? 2 : this.moduleOptionsRFA[0].checked == true ? 3 : 0
                  
                  setTimeout(() => {
                    this.moduleOptionsNFC[0].checked = false;
                    this.moduleOptionsNFC[0].dis = false;
                    this.moduleOptionsFCOJ[0].checked = false;
                    this.moduleOptionsFCOJ[0].dis = false;
                    this.moduleOptionsRFA[0].checked = false;
                    this.moduleOptionsRFA[0].dis = false;

                    if(option == 1) this.changeModuleNFC(this.moduleOptionsNFC[0])
                    if(option == 2) this.changeModuleFCOJ(this.moduleOptionsFCOJ[0])
                    if(option == 3) this.changeModuleRFA(this.moduleOptionsRFA[0])

                  }, 300);
                } 
              }

              if (propOfLine.key == "status" && ParseToNumber(propOfLine.value) == 0 && propOfLine.index.includes("EX_103")) 
              {
                if(pair103Off) 
                {
                  let option = this.moduleOptionsNFC[1].checked == true ? 1 : this.moduleOptionsFCOJ[1].checked == true ? 2 : this.moduleOptionsRFA[1].checked == true ? 3 : 0
                  
                  setTimeout(() => {
                    this.moduleOptionsNFC[1].checked = false;
                    this.moduleOptionsNFC[1].dis = false;
                    this.moduleOptionsFCOJ[1].checked = false;
                    this.moduleOptionsFCOJ[1].dis = false;
                    this.moduleOptionsRFA[1].checked = false;
                    this.moduleOptionsRFA[1].dis = false;

                    if(option == 1) this.changeModuleNFC(this.moduleOptionsNFC[1])
                    if(option == 2) this.changeModuleFCOJ(this.moduleOptionsFCOJ[1])
                    if(option == 3) this.changeModuleRFA(this.moduleOptionsRFA[1])

                  }, 300);
                } 
              }

              if (propOfLine.key == "status" && ParseToNumber(propOfLine.value) == 0 && propOfLine.index.includes("EX_105")) 
              {
                if(pair105Off) 
                {
                  let option = this.moduleOptionsNFC[2].checked == true ? 1 : this.moduleOptionsFCOJ[2].checked == true ? 2 : this.moduleOptionsRFA[2].checked == true ? 3 : 0
                  
                  setTimeout(() => {
                    this.moduleOptionsNFC[2].checked = false;
                    this.moduleOptionsNFC[2].dis = false;
                    this.moduleOptionsFCOJ[2].checked = false;
                    this.moduleOptionsFCOJ[2].dis = false;
                    this.moduleOptionsRFA[2].checked = false;
                    this.moduleOptionsRFA[2].dis = false;

                    if(option == 1) this.changeModuleNFC(this.moduleOptionsNFC[2])
                    if(option == 2) this.changeModuleFCOJ(this.moduleOptionsFCOJ[2])
                    if(option == 3) this.changeModuleRFA(this.moduleOptionsRFA[2])

                  }, 300);
                } 
              }

              if (propOfLine.key == "status" && ParseToNumber(propOfLine.value) == 0 && propOfLine.index.includes("EX_107")) 
              {
                if(pair107Off) 
                {
                  let option = this.moduleOptionsNFC[3].checked == true ? 1 : this.moduleOptionsFCOJ[3].checked == true ? 2 : this.moduleOptionsRFA[3].checked == true ? 3 : 0
                  
                  setTimeout(() => {
                    this.moduleOptionsNFC[3].checked = false;
                    this.moduleOptionsNFC[3].dis = false;
                    this.moduleOptionsFCOJ[3].checked = false;
                    this.moduleOptionsFCOJ[3].dis = false;
                    this.moduleOptionsRFA[3].checked = false;
                    this.moduleOptionsRFA[3].dis = false;

                    if(option == 1) this.changeModuleNFC(this.moduleOptionsNFC[3])
                    if(option == 2) this.changeModuleFCOJ(this.moduleOptionsFCOJ[3])
                    if(option == 3) this.changeModuleRFA(this.moduleOptionsRFA[3])

                  }, 300);
                } 
              }

              if (propOfLine.key == "status" && ParseToNumber(propOfLine.value) == 0 && propOfLine.index.includes("EX_109")) 
              {
                if(pair109Off) 
                {
                  let option = this.moduleOptionsNFC[4].checked == true ? 1 : this.moduleOptionsFCOJ[4].checked == true ? 2 : this.moduleOptionsRFA[4].checked == true ? 3 : 0
                  
                  setTimeout(() => {
                    this.moduleOptionsNFC[4].checked = false;
                    this.moduleOptionsNFC[4].dis = false;
                    this.moduleOptionsFCOJ[4].checked = false;
                    this.moduleOptionsFCOJ[4].dis = false;
                    this.moduleOptionsRFA[4].checked = false;
                    this.moduleOptionsRFA[4].dis = false;

                    if(option == 1) this.changeModuleNFC(this.moduleOptionsNFC[4])
                    if(option == 2) this.changeModuleFCOJ(this.moduleOptionsFCOJ[4])
                    if(option == 3) this.changeModuleRFA(this.moduleOptionsRFA[4])

                  }, 300);
                } 
              }
          });
        });
        
        //Para o caso de existir 1 MODULO
        if (this.moduleOptionsFCOJ.length == 1) 
        {
          this.moduleOptionsFCOJ.forEach(module => 
          {
            if (module.checked) 
            {
              this.node.data.forEach((a) => 
              {
                if (a.index.includes("EX_101")) 
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1fcoj = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2fcoj = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3fcoj = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1fcoj = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2fcoj = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3fcoj = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1fcoj = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2fcoj = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3fcoj = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1fcoj = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2fcoj = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3fcoj = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1fcoj = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2fcoj = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3fcoj = ParseToNumber(a.value)
                  }
                }

                if (a.index.includes("EX_101") || a.index.includes("EX_102")) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
            } 
          });
          this.moduleOptionsNFC.forEach(module => 
          {
            if (module.checked) 
            {
              this.node.data.forEach((a) => 
              {
                if (a.index.includes("EX_101")) 
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                } 
              });
            } 
          });
          this.moduleOptionsRFA.forEach(module => 
          {
            if (module.checked) 
            {
              this.node.data.forEach((a) => 
              {
                if (a.index.includes("EX_101")) 
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                } 
              });
            } 
          });
        }

        //Definicao do menor modulo selecionado
        let fcojMinModule = '';
        let nfcMinModule = '';
        let rfaMinModule = '';

        //Para o caso de existir 2 MODULOS
        if (this.moduleOptionsFCOJ.length == 2) 
        {
          this.moduleOptionsFCOJ.forEach(module => 
          {
            if (module.checked && fcojMinModule == '') 
            {
              fcojMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : '' ;
            }
          });

          this.moduleOptionsNFC.forEach(module => 
          {
            if (module.checked && nfcMinModule == 0) 
            {
              nfcMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : '' ;
            }
          });

          this.moduleOptionsRFA.forEach(module => 
          {
            if (module.checked && rfaMinModule == 0) 
            {
              rfaMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : '' ;
            }
          });
        }

        if (fcojMinModule != '') 
        {
          this.node.data.forEach((a) => 
            {
              let secondLine = fcojMinModule == "EX_101" ? "EX_102" : fcojMinModule == "EX_103" ? "EX_104" : fcojMinModule == "EX_105" ? "EX_106" :  fcojMinModule == "EX_107" ? "EX_108" : "";
              
              if (a.index.includes(fcojMinModule)) 
              {
                if(a.key == "fm_mp1") 
                {
                  this.inputLabel.citrus.chields.fmmp1fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "fm_mp2") 
                {
                  this.inputLabel.citrus.chields.fmmp2fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "fm_mp3") 
                {
                  this.inputLabel.citrus.chields.fmmp3fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp1") 
                {
                  this.inputLabel.citrus.chields.brixmp1fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp2") 
                {
                  this.inputLabel.citrus.chields.brixmp2fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "brix_mp3") 
                {
                  this.inputLabel.citrus.chields.brixmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "acidez_mp1") 
                {
                  this.inputLabel.citrus.chields.acidezmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp2") 
                {
                  this.inputLabel.citrus.chields.acidezmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp3") 
                {
                  this.inputLabel.citrus.chields.acidezmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "frutas_por_cx_mp1") 
                {
                  this.inputLabel.citrus.chields.tamanhomp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp2" ) 
                {
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp3") 
                {
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "porcsucomp1") 
                {
                  this.inputLabel.citrus.chields.sucocxmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp2") 
                {
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp3") 
                {
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = ParseToNumber(a.value)
                }
              }

              if(a.index.includes(fcojMinModule) || a.index.includes(secondLine)) 
              {
                if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
              }
          });
        }

        if (nfcMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = nfcMinModule == "EX_101" ? "EX_102" : nfcMinModule == "EX_103" ? "EX_104" : nfcMinModule == "EX_105" ? "EX_106" :  nfcMinModule == "EX_107" ? "EX_108" : "";

                if (a.index.includes(nfcMinModule))  
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3nfc = ParseToNumber(a.value)
                  }
                }

                if(a.index.includes(nfcMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }

        if (rfaMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = rfaMinModule == "EX_101" ? "EX_102" : rfaMinModule == "EX_103" ? "EX_104" : rfaMinModule == "EX_105" ? "EX_106" :  rfaMinModule == "EX_107" ? "EX_108" : "";

                if (a.index.includes(rfaMinModule)) 
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3rfa = ParseToNumber(a.value)
                  }
                }
                
                if (a.index.includes(rfaMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }
        
        //Zerando menore modulos
        fcojMinModule = '';
        nfcMinModule = '';
        rfaMinModule = '';

        //Para o caso 3 MODULOS
        if (this.moduleOptionsFCOJ.length == 3) 
        {
          this.moduleOptionsFCOJ.forEach(module => 
          {
            if (module.checked && fcojMinModule == '') 
            {
              fcojMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : '';
            }
          });

          this.moduleOptionsNFC.forEach(module => 
          {
            if (module.checked && nfcMinModule == 0) 
            {
              nfcMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : '' ;
            }
          });

          this.moduleOptionsRFA.forEach(module => 
          {
            if (module.checked && rfaMinModule == 0) 
            {
              rfaMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : '' ;
            }
          });
        }

        if (fcojMinModule != '') 
        {
          this.node.data.forEach((a) => 
            {
              let secondLine = fcojMinModule == "EX_101" ? "EX_102" : fcojMinModule == "EX_103" ? "EX_104" : fcojMinModule == "EX_105" ? "EX_106" :  fcojMinModule == "EX_107" ? "EX_108" : "";

              if (a.index.includes(fcojMinModule)) 
              {
                if(a.key == "fm_mp1") 
                {
                  this.inputLabel.citrus.chields.fmmp1fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "fm_mp2") 
                {
                  this.inputLabel.citrus.chields.fmmp2fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "fm_mp3") 
                {
                  this.inputLabel.citrus.chields.fmmp3fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp1") 
                {
                  this.inputLabel.citrus.chields.brixmp1fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp2") 
                {
                  this.inputLabel.citrus.chields.brixmp2fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "brix_mp3") 
                {
                  this.inputLabel.citrus.chields.brixmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "acidez_mp1") 
                {
                  this.inputLabel.citrus.chields.acidezmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp2") 
                {
                  this.inputLabel.citrus.chields.acidezmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp3") 
                {
                  this.inputLabel.citrus.chields.acidezmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "frutas_por_cx_mp1") 
                {
                  this.inputLabel.citrus.chields.tamanhomp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp2" ) 
                {
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp3") 
                {
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "porcsucomp1") 
                {
                  this.inputLabel.citrus.chields.sucocxmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp2") 
                {
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp3") 
                {
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = ParseToNumber(a.value)
                }
              }
              
              if (a.index.includes(fcojMinModule) || a.index.includes(secondLine)) 
              {
                if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
              }
          });
        }

        if (nfcMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = nfcMinModule == "EX_101" ? "EX_102" : nfcMinModule == "EX_103" ? "EX_104" : nfcMinModule == "EX_105" ? "EX_106" :  nfcMinModule == "EX_107" ? "EX_108" : "";

                if (a.index.includes(nfcMinModule))  
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3nfc = ParseToNumber(a.value)
                  }
                }
                
                if (a.index.includes(nfcMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }

        if (rfaMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = rfaMinModule == "EX_101" ? "EX_102" : rfaMinModule == "EX_103" ? "EX_104" : rfaMinModule == "EX_105" ? "EX_106" :  rfaMinModule == "EX_107" ? "EX_108" : "";

                if (a.index.includes(rfaMinModule)) 
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3rfa = ParseToNumber(a.value)
                  }
                }

                if (a.index.includes(rfaMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }

        //Zerando menore modulos
        fcojMinModule = '';
        nfcMinModule = '';
        rfaMinModule = '';

        //Para o caso 4 MODULOS
        if (this.moduleOptionsFCOJ.length == 4) 
        {
          this.moduleOptionsFCOJ.forEach(module => 
          {
            if (module.checked && fcojMinModule == '') 
            {
              fcojMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : module.name == "Módulo 4" ? 'EX_107' : '';
            }
          });

          this.moduleOptionsNFC.forEach(module => 
          {
            if (module.checked && nfcMinModule == 0) 
            {
              nfcMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : module.name == "Módulo 4" ? 'EX_107' : '';
            }
          });

          this.moduleOptionsRFA.forEach(module => 
          {
            if (module.checked && rfaMinModule == 0) 
            {
              rfaMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : module.name == "Módulo 4" ? 'EX_107' : '';
            }
          });
        }

        if (fcojMinModule != '') 
        {
          this.node.data.forEach((a) => 
            {
              let secondLine = fcojMinModule == "EX_101" ? "EX_102" : fcojMinModule == "EX_103" ? "EX_104" : fcojMinModule == "EX_105" ? "EX_106" :  fcojMinModule == "EX_107" ? "EX_108" : "";
              
              if (a.index.includes(fcojMinModule)) 
              {
                if(a.key == "fm_mp1") 
                {
                  this.inputLabel.citrus.chields.fmmp1fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "fm_mp2") 
                {
                  this.inputLabel.citrus.chields.fmmp2fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "fm_mp3") 
                {
                  this.inputLabel.citrus.chields.fmmp3fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp1") 
                {
                  this.inputLabel.citrus.chields.brixmp1fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp2") 
                {
                  this.inputLabel.citrus.chields.brixmp2fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "brix_mp3") 
                {
                  this.inputLabel.citrus.chields.brixmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "acidez_mp1") 
                {
                  this.inputLabel.citrus.chields.acidezmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp2") 
                {
                  this.inputLabel.citrus.chields.acidezmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp3") 
                {
                  this.inputLabel.citrus.chields.acidezmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "frutas_por_cx_mp1") 
                {
                  this.inputLabel.citrus.chields.tamanhomp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp2" ) 
                {
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp3") 
                {
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "porcsucomp1") 
                {
                  this.inputLabel.citrus.chields.sucocxmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp2") 
                {
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp3") 
                {
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = ParseToNumber(a.value)
                }
              }

              if (a.index.includes(fcojMinModule) || a.index.includes(secondLine)) 
              {
                if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
              }
          });
        }

        if (nfcMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = nfcMinModule == "EX_101" ? "EX_102" : nfcMinModule == "EX_103" ? "EX_104" : nfcMinModule == "EX_105" ? "EX_106" :  nfcMinModule == "EX_107" ? "EX_108" : "";
                
                if (a.index.includes(nfcMinModule))  
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3nfc = ParseToNumber(a.value)
                  }
                }

                if (a.index.includes(nfcMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }

        if (rfaMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = rfaMinModule == "EX_101" ? "EX_102" : rfaMinModule == "EX_103" ? "EX_104" : rfaMinModule == "EX_105" ? "EX_106" :  rfaMinModule == "EX_107" ? "EX_108" : "";
                
                if (a.index.includes(rfaMinModule)) 
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3rfa = ParseToNumber(a.value)
                  }
                }

                if (a.index.includes(rfaMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }

        //Zerando menore modulos
        fcojMinModule = '';
        nfcMinModule = '';
        rfaMinModule = '';

        //Para o caso 5 MODULOS
        if (this.moduleOptionsFCOJ.length == 5) 
        {
          this.moduleOptionsFCOJ.forEach(module => 
          {
            if (module.checked && fcojMinModule == '') 
            {
              fcojMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : module.name == "Módulo 4" ? 'EX_107' : module.name == "Módulo 5" ? 'EX_109' : '';
            }
          });

          this.moduleOptionsNFC.forEach(module => 
          {
            if (module.checked && nfcMinModule == 0) 
            {
              nfcMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : module.name == "Módulo 4" ? 'EX_107' : module.name == "Módulo 5" ? 'EX_109' : '';
            }
          });

          this.moduleOptionsRFA.forEach(module => 
          {
            if (module.checked && rfaMinModule == 0) 
            {
              rfaMinModule = module.name == "Módulo 1" ? 'EX_101' : module.name == "Módulo 2" ? 'EX_103' : module.name == "Módulo 3" ? 'EX_105' : module.name == "Módulo 4" ? 'EX_107' : module.name == "Módulo 5" ? 'EX_109' : '';
            }
          });
        }

        if (fcojMinModule != '') 
        {
          this.node.data.forEach((a) => 
            {
              let secondLine = fcojMinModule == "EX_101" ? "EX_102" : fcojMinModule == "EX_103" ? "EX_104" : fcojMinModule == "EX_105" ? "EX_106" :  fcojMinModule == "EX_107" ? "EX_108" : "";

              if (a.index.includes(fcojMinModule)) 
              {
                if(a.key == "fm_mp1") 
                {
                  this.inputLabel.citrus.chields.fmmp1fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "fm_mp2") 
                {
                  this.inputLabel.citrus.chields.fmmp2fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "fm_mp3") 
                {
                  this.inputLabel.citrus.chields.fmmp3fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp1") 
                {
                  this.inputLabel.citrus.chields.brixmp1fcoj = ParseToNumber(a.value)
                } 
                
                if(a.key == "brix_mp2") 
                {
                  this.inputLabel.citrus.chields.brixmp2fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "brix_mp3") 
                {
                  this.inputLabel.citrus.chields.brixmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "acidez_mp1") 
                {
                  this.inputLabel.citrus.chields.acidezmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp2") 
                {
                  this.inputLabel.citrus.chields.acidezmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "acidez_mp3") 
                {
                  this.inputLabel.citrus.chields.acidezmp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "frutas_por_cx_mp1") 
                {
                  this.inputLabel.citrus.chields.tamanhomp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp2" ) 
                {
                  this.inputLabel.citrus.chields.tamanhomp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "frutas_por_cx_mp3") 
                {
                  this.inputLabel.citrus.chields.tamanhomp3fcoj = ParseToNumber(a.value)
                }
                
                if(a.key == "porcsucomp1") 
                {
                  this.inputLabel.citrus.chields.sucocxmp1fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp2") 
                {
                  this.inputLabel.citrus.chields.sucocxmp2fcoj = ParseToNumber(a.value)
                }
                
                if (a.key == "porcsucomp3") 
                {
                  this.inputLabel.citrus.chields.sucocxmp3fcoj = ParseToNumber(a.value)
                }
              }

              if (a.index.includes(fcojMinModule) || a.index.includes(secondLine)) 
              {
                if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
              }
          });
        }

        if (nfcMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = nfcMinModule == "EX_101" ? "EX_102" : nfcMinModule == "EX_103" ? "EX_104" : nfcMinModule == "EX_105" ? "EX_106" :  nfcMinModule == "EX_107" ? "EX_108" : "";

                if (a.index.includes(nfcMinModule))  
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1nfc = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3nfc = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2nfc = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3nfc = ParseToNumber(a.value)
                  }
                }

                if (a.index.includes(nfcMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }

        if (rfaMinModule != '') 
        {
          this.node.data.forEach((a) => 
              {
                let secondLine = rfaMinModule == "EX_101" ? "EX_102" : rfaMinModule == "EX_103" ? "EX_104" : rfaMinModule == "EX_105" ? "EX_106" :  rfaMinModule == "EX_107" ? "EX_108" : "";

                if (a.index.includes(rfaMinModule)) 
                {
                  if(a.key == "fm_mp1") 
                  {
                    this.inputLabel.citrus.chields.fmmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "fm_mp2") 
                  {
                    this.inputLabel.citrus.chields.fmmp2rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "fm_mp3") 
                  {
                    this.inputLabel.citrus.chields.fmmp3rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp1") 
                  {
                    this.inputLabel.citrus.chields.brixmp1rfa = ParseToNumber(a.value)
                  } 
                  
                  if(a.key == "brix_mp2") 
                  {
                    this.inputLabel.citrus.chields.brixmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "brix_mp3") 
                  {
                    this.inputLabel.citrus.chields.brixmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "acidez_mp1") 
                  {
                    this.inputLabel.citrus.chields.acidezmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp2") 
                  {
                    this.inputLabel.citrus.chields.acidezmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "acidez_mp3") 
                  {
                    this.inputLabel.citrus.chields.acidezmp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "frutas_por_cx_mp1") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp2" ) 
                  {
                    this.inputLabel.citrus.chields.tamanhomp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "frutas_por_cx_mp3") 
                  {
                    this.inputLabel.citrus.chields.tamanhomp3rfa = ParseToNumber(a.value)
                  }
                  
                  if(a.key == "porcsucomp1") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp1rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp2") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp2rfa = ParseToNumber(a.value)
                  }
                  
                  if (a.key == "porcsucomp3") 
                  {
                    this.inputLabel.citrus.chields.sucocxmp3rfa = ParseToNumber(a.value)
                  }
                }

                if (a.index.includes(rfaMinModule) || a.index.includes(secondLine)) 
                {
                  if(a.key != "TBS" && a.key != "Umidade") attrs.push(a)
                  if(!this.inputLabel.citrus.current && a.observation) this.inputLabel.citrus.current = attrs[0].index
                }
              });
        }
        
        setTimeout(() => {
          let fcojzero = true;
          let nfczero = true;
          let rfazero = true;

          this.moduleOptionsFCOJ.forEach(module => 
          {
            if(module.checked) fcojzero = false  
          });

          this.moduleOptionsNFC.forEach(module => 
          {
            if(module.checked) nfczero = false  
          });

          this.moduleOptionsRFA.forEach(module => 
          {
            if(module.checked) rfazero = false  
          });

          if(fcojzero) 
          {
            this.inputLabel.citrus.chields.fmmp1fcoj = 0
            this.inputLabel.citrus.chields.fmmp2fcoj = 0
            this.inputLabel.citrus.chields.fmmp3fcoj = 0
            this.inputLabel.citrus.chields.brixmp1fcoj = 0
            this.inputLabel.citrus.chields.brixmp2fcoj = 0
            this.inputLabel.citrus.chields.brixmp3fcoj = 0
            this.inputLabel.citrus.chields.acidezmp1fcoj = 0
            this.inputLabel.citrus.chields.acidezmp2fcoj = 0
            this.inputLabel.citrus.chields.acidezmp3fcoj = 0
            this.inputLabel.citrus.chields.tamanhomp1fcoj = 0
            this.inputLabel.citrus.chields.tamanhomp2fcoj = 0
            this.inputLabel.citrus.chields.tamanhomp3fcoj = 0
            this.inputLabel.citrus.chields.sucocxmp1fcoj = 0
            this.inputLabel.citrus.chields.sucocxmp2fcoj = 0
            this.inputLabel.citrus.chields.sucocxmp3fcoj = 0
          }
          if(nfczero) 
          {
            this.inputLabel.citrus.chields.fmmp1nfc = 0
            this.inputLabel.citrus.chields.fmmp2nfc = 0
            this.inputLabel.citrus.chields.fmmp3nfc = 0
            this.inputLabel.citrus.chields.brixmp1nfc = 0
            this.inputLabel.citrus.chields.brixmp2nfc = 0
            this.inputLabel.citrus.chields.brixmp3nfc = 0
            this.inputLabel.citrus.chields.acidezmp1nfc = 0
            this.inputLabel.citrus.chields.acidezmp2nfc = 0
            this.inputLabel.citrus.chields.acidezmp3nfc = 0
            this.inputLabel.citrus.chields.tamanhomp1nfc = 0
            this.inputLabel.citrus.chields.tamanhomp2nfc = 0
            this.inputLabel.citrus.chields.tamanhomp3nfc = 0
            this.inputLabel.citrus.chields.sucocxmp1nfc = 0
            this.inputLabel.citrus.chields.sucocxmp2nfc = 0
            this.inputLabel.citrus.chields.sucocxmp3nfc = 0
          }
          if(rfazero) 
          {
            this.inputLabel.citrus.chields.fmmp1rfa = 0
            this.inputLabel.citrus.chields.fmmp2rfa = 0
            this.inputLabel.citrus.chields.fmmp3rfa = 0
            this.inputLabel.citrus.chields.brixmp1rfa = 0
            this.inputLabel.citrus.chields.brixmp2rfa = 0
            this.inputLabel.citrus.chields.brixmp3rfa = 0
            this.inputLabel.citrus.chields.acidezmp1rfa = 0
            this.inputLabel.citrus.chields.acidezmp2rfa = 0
            this.inputLabel.citrus.chields.acidezmp3rfa = 0
            this.inputLabel.citrus.chields.tamanhomp1rfa = 0
            this.inputLabel.citrus.chields.tamanhomp2rfa = 0
            this.inputLabel.citrus.chields.tamanhomp3rfa = 0
            this.inputLabel.citrus.chields.sucocxmp1rfa = 0
            this.inputLabel.citrus.chields.sucocxmp2rfa = 0
            this.inputLabel.citrus.chields.sucocxmp3rfa = 0
          }
        }, 200);

        this.inputLabel.citrus.attrs = attrs;
        this.firstLoad = false;
      },
      
      updateNode(){
        if(this.firstLoad) return;
        this.node.attrs = [...this.inputLabel.citrus.attrs]

        this.node.disableFCOJ = this.disableFCOJ;
        this.node.disableNFC = this.disableNFC;
        this.node.disableRFA = this.disableRFA;

        this.node.enableDoubledFCOJ = this.enableDoubledFCOJ;
        this.node.enableDoubledNFC = this.enableDoubledNFC;
        this.node.enableDoubledRFA = this.enableDoubledRFA;
        
        this.node.moduleOptionsFCOJ = this.moduleOptionsFCOJ;
        this.node.moduleOptionsNFC = this.moduleOptionsNFC;
        this.node.moduleOptionsRFA = this.moduleOptionsRFA;
        
        this.node.propPrecoce = this.propPrecoce;
        this.node.propMedia = this.propMedia;
        this.node.propTardia = this.propTardia;

        this.node.linesFCOJ = this.linesFCOJ;
        this.node.linesNFC = this.linesNFC;
        this.node.linesRFA = this.linesRFA;
      },

      changeModuleFCOJ(item) 
      { 
        let line1OffMod = ''
        let line2OffMod = ''
        
        if (item.name == "Módulo 1") 
        {
          line1OffMod = "Custom|EX_101"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
        } 
        if (item.name == "Módulo 2") 
        {
          line1OffMod = "Custom|EX_103"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";
        } 
        if (item.name == "Módulo 3") 
        {
          line1OffMod = "Custom|EX_105"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";
        } 
        if (item.name == "Módulo 4") 
        {
          line1OffMod = "Custom|EX_107"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";
          } 
        if (item.name == "Módulo 5") 
        {
          line1OffMod = "Custom|EX_109"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";
        }

        if (!item.checked) 
        {
          if(line1OffMod != "") 
          {
            let propOpfcoj = SingletonEnginnering.getOperationsProperties(line1OffMod);
            propOpfcoj.forEach(props => {
              if(props.caption == "status") props.value = 0
            })
          }

          if(line2OffMod != "") 
          {
            let propOpfcoj = SingletonEnginnering.getOperationsProperties(line2OffMod);
            propOpfcoj.forEach(props => {
              if(props.caption == "status") props.value = 0
            })
          }

          this.moduleOptionsNFC.forEach(md => {
            if (md.name == item.name) md.dis = false;
          });
          this.moduleOptionsRFA.forEach(md => {
            if (md.name == item.name) md.dis = false;
          });
        } else 
        {
          if(line1OffMod != "") 
          {
            let propOpfcoj = SingletonEnginnering.getOperationsProperties(line1OffMod);
            propOpfcoj.forEach(props => {
              if(props.caption == "status") props.value = 1
            })
          }

          if(line2OffMod != "") 
          {
            let propOpfcoj = SingletonEnginnering.getOperationsProperties(line2OffMod);
            propOpfcoj.forEach(props => {
              if(props.caption == "status") props.value = 1
            })
          }

          this.moduleOptionsNFC.forEach(md => {
            if (md.name == item.name) md.dis = true;
          });
          this.moduleOptionsRFA.forEach(md => {
            if (md.name == item.name) md.dis = true;
          });
        }

        this.linesFCOJ = [];
        if(this.moduleOptionsFCOJ.length == 1) 
        {
          this.moduleOptionsFCOJ.forEach(md => {
            if (md.checked) 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            }
          });
        }

        else if(this.moduleOptionsFCOJ.length == 2) 
        {
          this.moduleOptionsFCOJ.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            }
          });
        } 

        else if(this.moduleOptionsFCOJ.length == 3) 
        {
          this.moduleOptionsFCOJ.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            }
          });
        }

        else if(this.moduleOptionsFCOJ.length == 4) 
        {
          this.moduleOptionsFCOJ.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 4") 
            {
              let line1 = "Custom|EX_107"
              let line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            }
          });
        }

        else if(this.moduleOptionsFCOJ.length == 5) 
        {
          this.moduleOptionsFCOJ.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 4") 
            {
              let line1 = "Custom|EX_107"
              let line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            } if (md.checked && md.name == "Módulo 5") 
            {
              let line1 = "Custom|EX_109"
              let line2 = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";

              this.linesFCOJ.push(line1);
              this.linesFCOJ.push(line2);
            }
          });
          
        } 
        this.updateNode();
        this.changeOperation("fcoj");
      },

      changeModuleNFC(item) 
      { 
        let line1OffMod = ''
        let line2OffMod = ''
  
        if (item.name == "Módulo 1") 
        {
          line1OffMod = "Custom|EX_101"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
        } 
        if (item.name == "Módulo 2") 
        {
          line1OffMod = "Custom|EX_103"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";
        } 
        if (item.name == "Módulo 3") 
        {
          line1OffMod = "Custom|EX_105"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";
        } 
        if (item.name == "Módulo 4") 
        {
          line1OffMod = "Custom|EX_107"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";
          } 
        if (item.name == "Módulo 5") 
        {
          line1OffMod = "Custom|EX_109"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";
        }

        if (!item.checked) 
        {
          if(line1OffMod != "") 
          {
            let propOpNFC = SingletonEnginnering.getOperationsProperties(line1OffMod);
            propOpNFC.forEach(props => {
              if(props.caption == "status") props.value = 0
            })
          }

          if(line2OffMod != "") 
          {
            let propOpNFC = SingletonEnginnering.getOperationsProperties(line2OffMod);
            propOpNFC.forEach(props => {
              if(props.caption == "status") props.value = 0
            })
          }
          
          this.moduleOptionsFCOJ.forEach(md => {
            if (md.name == item.name) md.dis = false;
          });
          this.moduleOptionsRFA.forEach(md => {
            if (md.name == item.name) md.dis = false;
          });
        } else 
        {
          if(line1OffMod != "") 
          {
            let propOpNFC = SingletonEnginnering.getOperationsProperties(line1OffMod);
            propOpNFC.forEach(props => {
              if(props.caption == "status") props.value = 1
            })
          }

          if(line2OffMod != "") 
          {
            let propOpNFC = SingletonEnginnering.getOperationsProperties(line2OffMod);
            propOpNFC.forEach(props => {
              if(props.caption == "status") props.value = 1
            })
          }

          this.moduleOptionsFCOJ.forEach(md => {
            if (md.name == item.name) md.dis = true;
          });
          this.moduleOptionsRFA.forEach(md => {
            if (md.name == item.name) md.dis = true;
          });
        }

        this.linesNFC = [];
        if(this.moduleOptionsNFC.length == 1) 
        {
          this.moduleOptionsNFC.forEach(md => {
            if (md.checked) 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            }
          });
        }

        else if(this.moduleOptionsNFC.length == 2) 
        {
          this.moduleOptionsNFC.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            }
          });
        } 

        else if(this.moduleOptionsNFC.length == 3) 
        {
          this.moduleOptionsNFC.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            }
          });
        }

        else if(this.moduleOptionsNFC.length == 4) 
        {
          this.moduleOptionsNFC.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 4") 
            {
              let line1 = "Custom|EX_107"
              let line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            }
          });
        }

        else if(this.moduleOptionsNFC.length == 5) 
        {
          this.moduleOptionsNFC.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 4") 
            {
              let line1 = "Custom|EX_107"
              let line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            } if (md.checked && md.name == "Módulo 5") 
            {
              let line1 = "Custom|EX_109"
              let line2 = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";

              this.linesNFC.push(line1);
              this.linesNFC.push(line2);
            }
          });
        } 
        this.updateNode();
        this.changeOperation("nfc");
      },

      changeModuleRFA(item) 
      { 
        let line1OffMod = ''
        let line2OffMod = ''
  
        if (item.name == "Módulo 1") 
        {
          line1OffMod = "Custom|EX_101"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
        } 
        if (item.name == "Módulo 2") 
        {
          line1OffMod = "Custom|EX_103"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";
        } 
        if (item.name == "Módulo 3") 
        {
          line1OffMod = "Custom|EX_105"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";
        } 
        if (item.name == "Módulo 4") 
        {
          line1OffMod = "Custom|EX_107"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";
          } 
        if (item.name == "Módulo 5") 
        {
          line1OffMod = "Custom|EX_109"
          line2OffMod = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";
        }

        if (!item.checked) 
        {
          if(line1OffMod != "") 
          {
            let propOpRFA = SingletonEnginnering.getOperationsProperties(line1OffMod);
            propOpRFA.forEach(props => {
              if(props.caption == "status") props.value = 0
            })
          } 

          if(line2OffMod != "") 
          {
            let propOpRFA = SingletonEnginnering.getOperationsProperties(line2OffMod);
            propOpRFA.forEach(props => {
              if(props.caption == "status") props.value = 0
            })
          }

          this.moduleOptionsFCOJ.forEach(md => {
            if (md.name == item.name) md.dis = false;
          });
          this.moduleOptionsNFC.forEach(md => {
            if (md.name == item.name) md.dis = false;
          });
        } else 
        {
          if(line1OffMod != "") 
          {
            let propOpRFA = SingletonEnginnering.getOperationsProperties(line1OffMod);
            propOpRFA.forEach(props => {
              if(props.caption == "status") props.value = 1
            })
          } 

          if(line2OffMod != "") 
          {
            let propOpRFA = SingletonEnginnering.getOperationsProperties(line2OffMod);
            propOpRFA.forEach(props => {
              if(props.caption == "status") props.value = 1
            })
          }

          this.moduleOptionsFCOJ.forEach(md => {
            if (md.name == item.name) md.dis = true;
          });
          this.moduleOptionsNFC.forEach(md => {
            if (md.name == item.name) md.dis = true;
          });
        }

        this.linesRFA = [];
        if(this.moduleOptionsRFA.length == 1) 
        {
          this.moduleOptionsRFA.forEach(md => {
            if (md.checked) 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            }
          });
        }

        else if(this.moduleOptionsRFA.length == 2) 
        {
          this.moduleOptionsRFA.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            }
          });
        } 

        else if(this.moduleOptionsRFA.length == 3) 
        {
          this.moduleOptionsRFA.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            }
          });
        }

        else if(this.moduleOptionsRFA.length == 4) 
        {
          this.moduleOptionsRFA.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 4") 
            {
              let line1 = "Custom|EX_107"
              let line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            }
          });
        }

        else if(this.moduleOptionsRFA.length == 5) 
        {
          this.moduleOptionsRFA.forEach(md => {
            if (md.checked && md.name == "Módulo 1") 
            {
              let line1 = "Custom|EX_101"
              let line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              
              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 2") 
            {
              let line1 = "Custom|EX_103"
              let line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 3") 
            {
              let line1 = "Custom|EX_105"
              let line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 4") 
            {
              let line1 = "Custom|EX_107"
              let line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            } if (md.checked && md.name == "Módulo 5") 
            {
              let line1 = "Custom|EX_109"
              let line2 = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";

              this.linesRFA.push(line1);
              this.linesRFA.push(line2);
            }
          });
        } 

        this.updateNode();
        this.changeOperation("rfa");
      },

      changeOperation(type){
        this.inputLabel.citrus.attrs = [];
        let firstLine = true;

        this.operationsCitrus.forEach(line => {
            let propOp = SingletonEnginnering.getOperationsProperties(line);
            propOp.forEach(props => {
              if(props.caption == "oleo_disp_mp1" && line == "Custom|EX_101")
              {
                this.inputLabel.citrus.chields.oleoFruta = ParseToNumber(NumberFormat(props.value))
              }
            });
        });

        this.operationsCitrus.forEach(line => {
            let propOp = SingletonEnginnering.getOperationsProperties(line);
            propOp.forEach(props => {
              if(props.caption == "oleo_disp_mp1")
              {
                props.value = NumberFormat(this.inputLabel.citrus.chields.oleoFruta)
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "oleo_disp_mp2")
              {
                props.value = NumberFormat(this.inputLabel.citrus.chields.oleoFruta)
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "oleo_disp_mp3")
              {
                props.value = NumberFormat(this.inputLabel.citrus.chields.oleoFruta)
                this.inputLabel.citrus.attrs.push(props)
              }
            });
        });


        if (this.linesRFA != undefined) 
        {
          this.linesRFA.forEach(line => {
            if (line == '') 
            {
              return; 
            }
  
            let propOp = SingletonEnginnering.getOperationsProperties(line);
            propOp.forEach(props => {
              if(props.caption == "tipo_produto")
              {
                props.value = 3;
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp1rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.fmmp1rfa = ParseToNumber(NumberFormat((props.value)))
                  this.inputLabel.citrus.attrs.push(props)
                }

                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1rfa)
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp2")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp2rfa == 0)  
                {

                  this.inputLabel.citrus.chields.fmmp2rfa = ParseToNumber(NumberFormat((props.value)))
                  this.inputLabel.citrus.attrs.push(props)
                }

                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2rfa)
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp3")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp3rfa == 0) 
                {
                  this.inputLabel.citrus.chields.fmmp3rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                }

                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3rfa)
                
                this.inputLabel.citrus.attrs.push(props)
              }
  
              if(props.caption == "brix_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp1rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.brixmp1rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp1rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "brix_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp2rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.brixmp2rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp2rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "brix_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp3rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.brixmp3rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp3rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if(props.caption == "acidez_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp1rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.acidezmp1rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp1rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "acidez_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp2rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.acidezmp2rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp2rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "acidez_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp3rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.acidezmp3rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp3rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if(props.caption == "frutas_por_cx_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp1rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.tamanhomp1rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp1rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "frutas_por_cx_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp2rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.tamanhomp2rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp2rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "frutas_por_cx_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp3rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.tamanhomp3rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp3rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if(props.caption == "porcsucomp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp1rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.sucocxmp1rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp1rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "porcsucomp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp2rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.sucocxmp2rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp2rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "porcsucomp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp3rfa == 0) 
                {
                  if (type == "rfa") this.inputLabel.citrus.chields.sucocxmp3rfa = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp3rfa)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
            });
            firstLine = false;
          });
        }

        if (this.linesNFC != undefined) 
        {
          firstLine = true;
          this.linesNFC.forEach(line => {
            if (line == '') 
            {
              return; 
            }
  
            let propOp = SingletonEnginnering.getOperationsProperties(line);
            propOp.forEach(props => {
              if(props.caption == "tipo_produto")
              {
                props.value = 1;
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp1nfc == 0) 
                {
                  this.inputLabel.citrus.chields.fmmp1nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                }
                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1nfc)
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp2")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp2nfc == 0) 
                {
                  this.inputLabel.citrus.chields.fmmp2nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                }

                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2nfc)
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp3")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp3nfc == 0) 
                {
                  this.inputLabel.citrus.chields.fmmp3nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                }

                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3nfc)
                
                this.inputLabel.citrus.attrs.push(props)
              }
  
              if(props.caption == "brix_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp1nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.brixmp1nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp1nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "brix_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp2nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.brixmp2nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp2nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "brix_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp3nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.brixmp3nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp3nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if(props.caption == "acidez_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp1nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.acidezmp1nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp1nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "acidez_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp2nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.acidezmp2nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp2nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "acidez_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp3nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.acidezmp3nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp3nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if(props.caption == "frutas_por_cx_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp1nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.tamanhomp1nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp1nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "frutas_por_cx_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp2nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.tamanhomp2nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp2nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "frutas_por_cx_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp3nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.tamanhomp3nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp3nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if(props.caption == "porcsucomp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp1nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.sucocxmp1nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp1nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "porcsucomp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp2nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.sucocxmp2nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp2nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "porcsucomp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp3nfc == 0) 
                {
                  if (type == "nfc") this.inputLabel.citrus.chields.sucocxmp3nfc = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp3nfc)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
            });
            firstLine = false;
          });
        }

        if (this.linesFCOJ != undefined) 
        {
          firstLine = true;
          this.linesFCOJ.forEach(line => {
            if (line == '') 
            {
              return; 
            }
  
            let propOp = SingletonEnginnering.getOperationsProperties(line);
            propOp.forEach(props => {
              if(props.caption == "tipo_produto")
              {
                props.value = 2;
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp1fcoj == 0) 
                {
                  this.inputLabel.citrus.chields.fmmp1fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                }

                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp1fcoj)
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp2")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp2fcoj == 0) 
                {
                  this.inputLabel.citrus.chields.fmmp2fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                }

                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp2fcoj)
  
                this.inputLabel.citrus.attrs.push(props)
              }
              if(props.caption == "fm_mp3")
              {
                if (firstLine && this.inputLabel.citrus.chields.fmmp3fcoj == 0) 
                {
                  this.inputLabel.citrus.chields.fmmp3fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                }
                
                props.value = NumberFormat(this.inputLabel.citrus.chields.fmmp3fcoj)
                
                this.inputLabel.citrus.attrs.push(props)
              }
  
              if(props.caption == "brix_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp1fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.brixmp1fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp1fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "brix_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp2fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.brixmp2fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp2fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "brix_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.brixmp3fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.brixmp3fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.brixmp3fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if(props.caption == "acidez_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp1fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.acidezmp1fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp1fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "acidez_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp2fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.acidezmp2fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp2fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "acidez_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.acidezmp3fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.acidezmp3fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.acidezmp3fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if(props.caption == "frutas_por_cx_mp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp1fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.tamanhomp1fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp1fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "frutas_por_cx_mp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp2fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.tamanhomp2fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp2fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "frutas_por_cx_mp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.tamanhomp3fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.tamanhomp3fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.tamanhomp3fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if(props.caption == "porcsucomp1")
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp1fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.sucocxmp1fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp1fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
              
              if (props.caption == "porcsucomp2") 
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp2fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.sucocxmp2fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp2fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
  
              if (props.caption == "porcsucomp3") 
              {
                if (firstLine && this.inputLabel.citrus.chields.sucocxmp3fcoj == 0) 
                {
                  if (type == "fcoj") this.inputLabel.citrus.chields.sucocxmp3fcoj = ParseToNumber(NumberFormat(props.value))
                  this.inputLabel.citrus.attrs.push(props)
                } else 
                {
                  props.value = NumberFormat(this.inputLabel.citrus.chields.sucocxmp3fcoj)
                  this.inputLabel.citrus.attrs.push(props)
                }
              }
            });
            firstLine = false;
          });
        }

        var modulesActive = []
        
        setTimeout(() => {
          this.moduleOptionsFCOJ.forEach(mdfcoj => {
            if((mdfcoj.dis || mdfcoj.checked) ) modulesActive.push(mdfcoj.name)
          });

          if(modulesActive.length > 0) 
          {
            modulesActive.forEach(modOn => {
              let line1 = ""
              let line2 = ""
  
              if (modOn == "Módulo 1") 
              {
                line1 = "Custom|EX_101"
                line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              } 
              if (modOn == "Módulo 2") 
              {
                line1 = "Custom|EX_103"
                line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";
              } 
              if (modOn == "Módulo 3") 
              {
                line1 = "Custom|EX_105"
                line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";
              } 
              if (modOn == "Módulo 4") 
              {
                line1 = "Custom|EX_107"
                line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";
              } 
              if (modOn == "Módulo 5") 
              {
                line1 = "Custom|EX_109"
                line2 = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";
              }
              
              let propOp1 = SingletonEnginnering.getOperationsProperties(line1);

              propOp1.forEach(props => {
              if(props.caption == "status")
              {
                props.value = 1;
  
                this.inputLabel.citrus.attrs.push(props)
              }})

              if(line2 != '') 
              {
                let propOp2 = SingletonEnginnering.getOperationsProperties(line2);
                propOp2.forEach(props => {
                if(props.caption == "status")
                {
                  props.value = 1;
                  
                  this.inputLabel.citrus.attrs.push(props)
                }})
              }
            });
          }
          this.updateNode();
        }, 500);

        setTimeout(() => {
          let modulesOff = []
          this.moduleOptionsFCOJ.forEach(mdfcoj => {
            if(!mdfcoj.dis && !mdfcoj.checked  && !modulesActive.includes(mdfcoj.name)) modulesOff.push(mdfcoj.name)
          });

          if(modulesOff.length > 0) 
          {
            modulesOff.forEach(modOFF => {
              let line1 = ""
              let line2 = ""
  
              if (modOFF == "Módulo 1") 
              {
                line1 = "Custom|EX_101"
                line2 = this.operationsCitrus.includes("Custom|EX_102") ? "Custom|EX_102" : "";
              } 
              if (modOFF == "Módulo 2") 
              {
                line1 = "Custom|EX_103"
                line2 = this.operationsCitrus.includes("Custom|EX_104") ? "Custom|EX_104" : "";
              } 
              if (modOFF == "Módulo 3") 
              {
                line1 = "Custom|EX_105"
                line2 = this.operationsCitrus.includes("Custom|EX_106") ? "Custom|EX_106" : "";
              } 
              if (modOFF == "Módulo 4") 
              {
                line1 = "Custom|EX_107"
                line2 = this.operationsCitrus.includes("Custom|EX_108") ? "Custom|EX_108" : "";
              } 
              if (modOFF == "Módulo 5") 
              {
                line1 = "Custom|EX_109"
                line2 = this.operationsCitrus.includes("Custom|EX_110") ? "Custom|EX_110" : "";
              }
              
              let propOp1 = SingletonEnginnering.getOperationsProperties(line1);

              propOp1.forEach(props => {
              if(props.caption == "status")
              {
                props.value = 0;
  
                this.inputLabel.citrus.attrs.push(props)
              }})

              if(line2 != '') 
              {
                let propOp2 = SingletonEnginnering.getOperationsProperties(line2);
                propOp2.forEach(props => {
                if(props.caption == "status")
                {
                  props.value = 0;
                  
                  this.inputLabel.citrus.attrs.push(props)
                }})
              }
            });
          }
          this.updateNode();
        }, 500);

        this.updateNode();
      },
    },
    
    mounted(){ 
      this.loadNode();
    },

    destroyed() {
      this.waitOff();
    },
  }
</script>

<style scoped>

.main{
  display: flex;
  font-size: 0.9rem;
}

.form-geral{
  display: flex;
  width: max-content;
}

.form-geral-read{
  display: flex;
  width: max-content;
}

form{
  color: #0009;
}

.form-geral>p{
  display: inline;
  position: relative;
  padding: 4px;
  top: 9px;
  font-weight: bold;
  margin: 5px 0px 0px 3px;
  background-color: white;
}

.varExtrator{
  display: flex;
}

.varExtrat>p{
display: inline;
position: relative;
padding: 4px;
top: 9px;
font-weight: bold;
margin: 5px 0px 0px 3px;
background-color: white;
}

.box-edit{
  padding: 8px;
  box-shadow: 0px 0px 3px #0008;
  border-radius: 3px;
}

.box-edit>span{
  display: flex;
  justify-content: space-between;
}

.box-edit>span>input {
  width: 88px;
  height: 20px;
  text-align: right;
  border: #ff5f00 solid 1px;
}

.input-prop {
  width: 70px !important; 
  height: 20px;
  text-align: right;
  border: #ff5f00 solid 1px;
}

.box-edit>span>label{
  margin-left: 5px;
  margin-bottom: 2px;
}


.box-edit>span>input:focus{
  box-shadow: 0px 0px 5px #ff5f00;
}

.form-geral.readOnly>p{
  background-color: #fafafa;
}

.form-geral.readOnly>div>div>p{
  background-color: #fafafa;
}

.varExtrat>div>p{
  display: inline;
  position: relative;
  padding: 4px;
  top: 9px;
  font-weight: bold;
  margin: 5px 0px 0px 3px;
  background-color: #fafafa;
}

.labelop {
  margin-bottom: 6px;
}

.box-80 
{
 height: 80%;
}

.menu-mod 
{
  margin-left: 18px;
}

.frutaSel 
{
  margin-top: 3px;
  margin-bottom: 5px;
}

.div-top
{
  margin-top: -4px;
}

.box-conf
{
  box-shadow: none;
  padding: 2px;
}

.frutaSel2 
{
  margin-top: 2px;
}

.box-group 
{
  display: flex;
}

.span-menu 
{
  align-items: center;
  justify-content: center;
}

.span-oleo
{
  position: absolute;
  bottom: 8px;
}

.span-oleo-p
{
  position: absolute !important; 
  top: 635px !important;  
  z-index: 1 !important;
  background-color: #fafafa !important;
}

.span-oleo-read-pos
{
  bottom: 5px !important;
}

.input-oleo 
{
  margin-top: 3px;
  width: 94px !important;
}

</style>